//
//
//
//
//
//
//

import '@/common/web2weapp.js'

const weapp_config = {
    appId: 'wx8ac1395283aea132',
    env_ID: 'cdgft-2bfho',
    gh_ID: 'gh_9af070659ca5'
}

export default {
    mounted () {
        window.web2weapp.preinit()
    },
    methods: {
        openMini () {
            window.web2weapp.init({
                ...weapp_config,
                function: {
                    name: 'openMini',
                    data: {
                        action: 'getUrlScheme',
                        path: 'pages/check_condition/main',
                        query: {}
                    }
                },
                path: 'pages/index/main'
            })
        }
    }
}
